import { Grid } from '@mui/material';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import CheckoutForm from './checkout-form';

// Make sure to call loadStripe outside of a component's render to avoid
// recreating the Stripe object on every render.
// This is your test publishable API key.
const stripe = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '');

export enum StripeCheckoutType {
  Payment = 'payment',
  Setup = 'setup',
}

type Props = {
  clientSecret: string;
};

export default function CheckoutFormContainer({ clientSecret }: Props) {
  const elementsOptions = {
    clientSecret: clientSecret,
    appearance: {
      rules: {
        '.Label': {
          fontSize: '.70em',
          fontWeight: 'bold',
        },
      },
    },
  };

  const getClientSecretType = (): StripeCheckoutType => {
    if (clientSecret.startsWith('seti_')) {
      return StripeCheckoutType.Setup;
    }

    return StripeCheckoutType.Payment;
  };

  return (
    <div>
      <Grid xs={12} item md={12}>
        <Elements stripe={stripe} options={elementsOptions}>
          <CheckoutForm stripeCheckoutType={getClientSecretType()} />
        </Elements>
      </Grid>
    </div>
  );
}
